import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';


function PageNotFound(props) {

	var element =
		<>
			<main className="pageNotFound align-items-center d-flex">
				<Container>
					<Row className='justify-content-center'>
						<Col md={8} lg={6}>
							<div className='text-center bg-light my-4 py-5'>
								<h1 className='text-primary' style={{fontSize: "4rem"}}>- 404 -</h1>
								<h4>Sorry, Page Not Found</h4>
								<p className='mb-5'>The page you have requested could not be found</p>
								<a href='' className='text-uppercase btn btn-primary'>Back to Home Page</a>
							</div>
						</Col>
					</Row>
				</Container>
			</main>;
		</>


	return (
		element
	);
}

export default PageNotFound;